import constants from './revaConstants';
import initialState from './revaState';

export default (state = initialState, action) => {
    switch (action.type) {
        case constants.SET_REVA_ME:
            return {
                ...state,
                me: action.payload
            };
        case constants.SET_REVA_CONNECTION_ERROR:
            return {
                ...state,
                connectionError: action.payload
            };
        case constants.SET_REVA_LINEUPS:
            return {
                ...state,
                lineups: action.payload
            };
        case constants.SET_REVA_PLAYERS:
            return {
                ...state,
                players: action.payload
            };
        case constants.SET_REVA_ACCOUNTS:
            return {
                ...state,
                accounts: action.payload
            };
        case constants.SET_REVA_LINEUP_FINANCIALS:
            return {
                ...state,
                selectedLineupFinancials: action.payload
            };
        case constants.SET_REVA_PLAYER_FINANCIALS:
            return {
                ...state,
                selectedPlayerFinancials: action.payload
            };
        case constants.SET_REVA_PRICE_LIST:
            return {
                ...state,
                priceLists: {
                    ...state.priceLists,
                    [action.payload.tournament_id]: action.payload.items
                }
            };
        case constants.UPDATE_REVA_LINEUP:
            return {
                ...state,
                lineups: state.lineups.map(lineup => 
                    lineup.id === action.payload.id || lineup.external_entity_id === action.payload.external_entity_id 
                        ? { ...lineup, ...action.payload } 
                        : lineup
                )
            };
        case constants.SET_REVA_DEBT_SUMMARY:
            return {
                ...state,
                debtSummary: action.payload
            };
        case constants.SET_REVA_LINEUP_INVOICES:
            return {
                ...state,
                selectedLineupInvoices: action.payload
            };
        case constants.SET_REVA_PLAYER_INVOICES:
            return {
                ...state,
                selectedPlayerInvoices: action.payload
            };
        case constants.SET_REVA_SILO_BALANCES:
            return {
                ...state,
                siloBalances: action.payload
            };
        case constants.SET_REVA_LINEUP_SILO_BALANCES:
            return {
                ...state,
                selectedLineupSiloBalances: action.payload
            };
        case constants.SET_REVA_INCOME_SUMMARY:
            return {
                ...state,
                incomeSummary: action.payload
            };
        case constants.SET_REVA_TRANSACTIONS_SUMMARY:
            return {
                ...state,
                transactionsSummary: action.payload
            };
        case constants.CLEAR_REVA_STATE:
            return initialState;
        default:
            return state;
    }
};
